export default "__VITE_ASSET__CdpUC$pf__"